export default __webpack_public_path__ + "static/media/pulp-fiction.527883ad.jpg";